import React from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import LoginPage from "../../components/Login";
import Footer from "../../components/Footer";

import './Login.styles.css';

const Login = () => {

	return (
		<div>
			<Helmet>
				<title>Log In</title>
			</Helmet>
			<Header />
			<LoginPage />
			<Footer />
		</div>
	);
};

export default Login;